import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { LOGO } from "@/data/exercises";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowLeft } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const KIND = { story: "Lecture de conte", message: "Mot doux", song: "Chanson", reply: "Réponse" };

// Page ouverte en scannant un code QR du livret souvenir.
export default function ListenVoice() {
  const { recId } = useParams();
  const navigate = useNavigate();
  const [v, setV] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get(`/voices/${recId}`).then((r) => setV(r.data)).catch(() => setError(true)); }, [recId]);
  const what = v && (v.kind === "story" ? v.story_title : v.kind === "song" ? v.song_title : "");
  return (
    <div className="min-h-screen bg-[#F4F0E8] font-care flex flex-col items-center px-5 py-10" data-testid="listen-voice-page">
      <img src={LOGO} alt="Passerelle" className="h-12 w-auto mb-8" />
      <div className="w-full max-w-lg rounded-[2rem] bg-white border border-amber-100 p-8 text-center shadow-sm">
        {error ? (
          <p className="text-lg text-gray-600" data-testid="listen-voice-error">Cet enregistrement n'existe plus ou ne vous est pas accessible.</p>
        ) : !v ? (
          <Loader2 className="w-8 h-8 animate-spin text-emerald-700 mx-auto" />
        ) : (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-amber-700 mb-2">{KIND[v.kind] || "Voix"} · {v.patient_name}</p>
            <h1 className="font-serif-display text-3xl text-gray-800 mb-1" data-testid="listen-voice-title">{what || `Message de ${v.label}`}</h1>
            <p className="text-gray-500 mb-6">Par {v.label} · {new Date(v.created_at).toLocaleDateString("fr-FR")}</p>
            <audio controls autoPlay src={`${BACKEND}${v.audio_url}`} className="w-full" data-testid="listen-voice-audio" />
          </>
        )}
      </div>
      <Button variant="ghost" className="mt-6" onClick={() => navigate("/")} data-testid="listen-voice-home"><ArrowLeft className="w-4 h-4 mr-2" /> Retour à l'accueil</Button>
    </div>
  );
}
